import React from 'react'
import { apiCall } from "../helpers/apiCall";
const UserPannel = () => {
  return (
    <div>
      user pannel
    </div>
  )
}

export default UserPannel
